import './SolutionSelector.scss';
import React, { useContext } from 'react';
import { SegmentContext } from '../../index'
import Button from '../Button'
import { solutionFilter } from '../App'

function SolutionSelector({ SolutionSelector }) {

  const { segment, solution, selectSolution } = useContext(SegmentContext)

  const selectedSolutionId = solution ? solution.id : undefined

  return (
    <div className={'solution-selector'}>
      { segment && segment.solutions.filter(solutionFilter).map((sol, index) => {
        return (
          <div key={index} className="solution-selector-item">
            <Button key={index} label={sol.name} active={sol.id === selectedSolutionId} onClick={e => { 
              if (sol.id === selectedSolutionId) {
                selectSolution(null)
              } else {
                selectSolution(sol.id)
              }
            } } />
          </div>
        )
      }) }
    </div>
  );
}

export default SolutionSelector;